import { useTranslation } from 'react-i18next';

export default function BarreUrgence() {
  const { t } = useTranslation('deneigement');

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-blue-ice">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10 py-2.5 flex items-center justify-center gap-3 text-white text-sm font-medium">
        <i className="ri-snowy-line text-lg" />
        <span>{t('urgence_text')} —</span>
        <a
          href="tel:+14184769950"
          aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
          title="Cliquez pour appeler"
          className="underline underline-offset-2 hover:text-white/80 transition-colors whitespace-nowrap"
        >
          {t('cta_phone')}
        </a>
      </div>
    </div>
  );
}